import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../lib/motion";

export const PageHero = ({ eyebrow, title, subtitle, children }) => {
  return (
    <section className="relative overflow-hidden pt-10 pb-16 md:pt-16 md:pb-24" data-testid="page-hero">
      <div className="absolute inset-0 subtle-radial" aria-hidden="true" />
      <div className="absolute inset-0 grid-lines-bg opacity-40" aria-hidden="true" />
      <div className="container-page relative">
        <motion.div {...fadeUp} className="max-w-3xl">
          {children && <div className="mb-6">{children}</div>}
          {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tighter leading-[1.02] text-slate-900 dark:text-white">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg md:text-xl text-slate-600 dark:text-slate-300 leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
